import _ from 'lodash';
import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_TABLE_ROW](state, p) {
    const drp = p.drp;
    drp.body.push(p.row);
  },
  [types.REMOVE_TABLE_ROW](state, p) {
    const drp = p.drp;
    drp.body.splice(p.index, 1);
  },
  [types.ADD_TABLE_COLUMN](state, p) {
    const drp = p.drp;
    drp.header.push(p.header);
    // add to each row
    _.forEach(drp.body, (row, index) => {
      row.cols.push(p.cols[index]);
    });
  },
  [types.REMOVE_TABLE_COLUMN](state, p) {
    const drp = p.drp;
    drp.header.splice(p.index, 1);
    _.forEach(drp.body, (row) => {
      row.cols.splice(p.index, 1);
    });
  },
  [types.SET_TABLE_HEADER_TEXT](state, p) {
    p.head.text = p.text;
  },
  [types.SET_TABLE_TD_TEXT](state, p) {
    p.td.text = p.text;
  },
};

const actions = {
  addTableRow: ({ commit }, payload) => {
    commit(types.ADD_TABLE_ROW, payload);
  },
  removeTableRow: ({ commit }, payload) => {
    commit(types.REMOVE_TABLE_ROW, payload);
  },
  addTableColumn: ({ commit }, payload) => {
    commit(types.ADD_TABLE_COLUMN, payload);
  },
  removeTableColumn: ({ commit }, payload) => {
    commit(types.REMOVE_TABLE_COLUMN, payload);
  },
  async setTableHeaderText({ dispatch, commit }, payload) {
    await commit(types.SET_TABLE_HEADER_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
  async setTableTdText({ dispatch, commit }, payload) {
    await commit(types.SET_TABLE_TD_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/table/vuex.js